"use client";

import type { CSSProperties, ReactNode } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { useListingIsland } from "./ManualListingsIsland";

/** A listing's details; the body is rendered on the server from the listing's view. The dialog is portalled out of the
 *  section, so it carries the family's class and the section's style variables itself. */
export default function ListingDialog({
  listingKey,
  title,
  className = "",
  style,
  children,
}: {
  listingKey: string;
  title: string;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) {
  const island = useListingIsland();
  return (
    <Dialog
      open={island.open === listingKey}
      onClose={island.closeDetails}
      className={`pf pf-family-manual-listings pf-ml-dialog ${className}`.trim()}
      style={style}
      data-purpose-family="manual-listings"
    >
      <div className="pf-modal-backdrop">
        <DialogPanel className="pf-modal pf-ml-details">
          <div className="pf-modal-heading">
            <DialogTitle as="h2" className="pf-ml-details-title">
              {title}
            </DialogTitle>
            <button
              type="button"
              aria-label="Luk"
              onClick={island.closeDetails}
            >
              ×
            </button>
          </div>
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
